import { useEffect, useRef, useState } from "react"
import { Formik, Field, Form } from "formik"
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    Wrapper,
    CombineInputGroup,
    ActionSection,
    ScrollableContent,
    SideCancelBtn,
    RupeeIcon,
    ModalHeader,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import moment from "moment"
import "react-datepicker/dist/react-datepicker.css";
import DropZone from "../Notice/Dropzone"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCheckCircle, FaRegCalendar, FaMoneyBillWave } from "react-icons/fa";
import { paymentModes } from "../../helpers"
import CategoryCard from "../CategoryCard"
import PaidUserModal from "./PaidUserModal"
import { useSelector } from "react-redux"
import { MenuItem, Select } from "@mui/material"

const MarkAsPaidOfflineModal = ({
    handleClose,
    selectedData,
    markPaidExpenseMutate,
    markPaidExpenseLoading,
    expenseData,
    route,
}) => {
    const bankAccountsArray = useSelector(
        (state) => state.BankAccountsReducer.bankAccounts
    );
    const bankAccounts = Array.isArray(bankAccountsArray) ? bankAccountsArray : [];
    const isStaffDetail = route === "/staff-detail";
    const isPaidToUserType3 = selectedData?.paidToUserType === 3;
    const hidePaymentType = isStaffDetail || isPaidToUserType3;
    const formikRef = useRef(null)
    const [calendarOpen, setCalendarOpen] = useState(false);
    const paymentTypes = [
        {
            label: "Full Payment",
            value: 0,
            icon: <FaCheckCircle className="w-6 h-6 text-green-500" />,
        },
        {
            label: "Partial Payment",
            value: 1,
            icon: <FaMoneyBillWave className="w-6 h-6 text-blue-500" />,
        },
    ];

    const defaultPaidDate = selectedData?.paidDate
        ? moment(selectedData.paidDate).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");


    const [selectedPaidBy, setSelectedPaidBy] = useState(null);
    const [showPaidByModal, setShowPaidByModal] = useState(false)
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (
            selectedData?.paidBy &&
            expenseData?.users?.length &&
            !selectedPaidBy &&
            formikRef.current
        ) {
            const defaultUser = expenseData.users.find(
                (u) => u.id === selectedData.paidBy
            );

            if (defaultUser) {
                setSelectedPaidBy(defaultUser);

                formikRef.current.setFieldValue("paidBy", defaultUser.id);
                formikRef.current.setFieldValue(
                    "paidByUserType",
                    defaultUser.userType
                );
            }
        }
    }, [selectedData, expenseData]);


    const initialValues = {
        amount: selectedData.balance,
        paidDate: defaultPaidDate,
        paidBy: "",
        paidTo: selectedData?.paidToName || selectedData?.landlordName,
        paymentMode: 0,
        expenseId: selectedData?.id,
        file: selectedData?.supportDoc,
        paymentType: 0,
        bankAccount: "",
    }

    const handleSelectedPaidBy = (selectedOption) => {
        setSelectedPaidBy(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("paidBy", selectedOption.id)
            formikRef.current.setFieldValue("paidByUserType", selectedOption.userType)
        }
    }

    const handlePaymentModeChange = (value) => {
        if (formikRef.current) {
            formikRef.current.setFieldValue("paymentMode", value)
        }
    }

    const handleSubmit = (values) => {
        const amountRegex = /^(?!0+$)\d{1,7}$/
        const maxAmount = 5000000

        if (!amountRegex.test(values.amount) || Number.parseInt(values.amount) > maxAmount) {
            toast.error("Monthly rent must be between 1 and 50,00,000 and contain only numbers")
            return
        }
        if (values.paymentType === 1) {
            if (Number(values.amount) > Number(selectedData.balance)) {
                toast.error(`Amount cannot exceed available balance of ₹${selectedData.balance}`)
                return
            }
        }

        if (!values.paidDate) {
            toast.error("Paid date is required")
            return
        }
        if (!values.paidBy) {
            toast.error("Paid by is required")
            return
        }
        if (!values.paymentMode) {
            toast.error("Payment mode is required")
            return
        }
        const selectedBankAccount = [2, 3, 4].includes(values.paymentMode)
            ? bankAccounts.find(acc => acc.id.toString() === values.bankAccount)
            : null;

        const formData = new FormData();
        formData.append("amount", Number(values.amount));
        formData.append("paidDate", moment(values.paidDate).format("YYYY-MM-DDTHH:mm:ss[Z]"));
        formData.append("paidBy", Number(values.paidBy));
        formData.append("isPartialPayment", Number(values.paymentType));
        formData.append("mode", values.paymentMode);
        formData.append("paidByUserType", Number(selectedPaidBy.userType));
        formData.append("paymentAccountNo", selectedBankAccount?.accountNum || "",)
        formData.append("paymentAccountName", selectedBankAccount?.holderName || "");
        formData.append("expenseId", Number(selectedData.id));
        if (values.file) {
            formData.append("file", values.file[0])
        }
        markPaidExpenseMutate(formData);
    }

    const handleBankAccountChange = (event, setFieldValue) => {
        const selectedId = event.target.value;
        setFieldValue("bankAccount", selectedId);

        const selectedAccount = bankAccounts.find(acc => acc.id.toString() === selectedId);
        if (selectedAccount) {
            setFieldValue("paymentAccountNo", selectedAccount.accountNum);
            setFieldValue("paymentAccountName", selectedAccount.holderName);
        }
    };

    const clearBankAccountFields = (setFieldValue) => {
        setFieldValue("bankAccount", "");
        setFieldValue("paymentAccountNo", "");
        setFieldValue("paymentAccountName", "");
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Mark Expense as Paid</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ values, setFieldValue, handleChange, resetForm }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>
                                    {/* {!hidePaymentType && ( */}
                                    <InputGroup>
                                        <Label htmlFor="paymentType">Payment Type *</Label>
                                        <div className="grid grid-cols-3 gap-2">
                                            {paymentTypes.map((option) => (
                                                <OptionCard
                                                    key={option.value}
                                                    type="button"
                                                    isselected={(values.paymentType === option.value).toString()}
                                                    onClick={() => {
                                                        setFieldValue("paymentType", option.value);
                                                        if (option.value === 0) {
                                                            setFieldValue("amount", selectedData.balance);
                                                        } else {
                                                            setFieldValue("amount", "");
                                                        }
                                                    }}
                                                >
                                                    <span className="text-sm">{option.label}</span>
                                                </OptionCard>
                                            ))}
                                        </div>
                                    </InputGroup>
                                    {/* )} */}
                                    <InputGroup>
                                        <Label htmlFor="amountPaid">
                                            {values.paymentType === 0 ? "Amount" : "Partial Amount"} *
                                        </Label>
                                        <FieldWrappers>
                                            <RupeeIcon />
                                            <Field
                                                type="text"
                                                name="amount"
                                                id="amount"
                                                className={`w-full truncate pl-5`}
                                                //value={userValues.balance}
                                                disabled={values.paymentType === 0}
                                            />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <CombineInputGroup>
                                        <InputGroup>
                                            <Label htmlFor="paidBy">Paid by *</Label>
                                            <CategoryCard
                                                title="Paid By"
                                                selectedCategory={selectedPaidBy}
                                                onClick={() => setShowPaidByModal(true)}
                                            />

                                        </InputGroup>

                                        <InputGroup>
                                            <Label htmlFor="paidTo">Paid to *</Label>
                                            <FieldWrappers className="bg-gray-100 h-16">
                                                <Field
                                                    type="text"
                                                    name="paidTo"
                                                    id="paidTo"
                                                    className={`w-full truncate `}
                                                    value={values.paidTo}
                                                    readOnly
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                    </CombineInputGroup>
                                    <InputGroup>
                                        <Label htmlFor="paidDate">Paid Date *</Label>
                                        <FieldWrappers className="relative">
                                            <DatePicker
                                                //selected={values.paidDate ? new Date(values.paidDate) : new Date()}
                                                selected={values.paidDate ? moment(values.paidDate, "YYYY-MM-DD").toDate() : null}
                                                onChange={(date) => {
                                                    const formattedDate = moment(date).format("YYYY-MM-DD");
                                                    handleChange({
                                                        target: {
                                                            name: "paidDate",
                                                            value: formattedDate,
                                                        },
                                                    });
                                                    setCalendarOpen(false);
                                                }}
                                                onClickOutside={() => setCalendarOpen(false)}
                                                onSelect={() => setCalendarOpen(false)}
                                                open={calendarOpen}
                                                onInputClick={() => setCalendarOpen(true)}
                                                dateFormat="yyyy-MM-dd"
                                                className="w-full truncate cursor-pointer"
                                                placeholderText="YYYY-MM-DD"
                                                showIcon
                                                icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                showPopperArrow={false}
                                                onFocus={(e) => e.target.blur()}
                                                wrapperClassName="w-full"
                                                required
                                                name="paidDate"
                                                id="paidDate"
                                                autoComplete="off"
                                                popperPlacement="bottom-start"
                                                portalId="root-portal"
                                                popperClassName="react-datepicker-popper"
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label>Payment Mode *</Label>
                                        <PaymentModeWrapper>
                                            {paymentModes.map((mode) => (
                                                <PaymentModeCard
                                                    key={mode.value}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setFieldValue("paymentMode", mode.value)
                                                        handlePaymentModeChange(mode.value);
                                                        clearBankAccountFields(setFieldValue);
                                                    }}
                                                    className={`${values.paymentMode === mode.value ? "bg-primary-color text-white" : "bg-gray-100"
                                                        } `}
                                                >
                                                    <span className="text-sm">{mode.label}</span>
                                                </PaymentModeCard>
                                            ))}
                                        </PaymentModeWrapper>
                                    </InputGroup>
                                    {/* Only show bank account dropdown if there are bank accounts */}
                                    {bankAccounts.length > 0 && [2, 3, 4].includes(values.paymentMode) && (
                                        <InputGroup>
                                            <Label htmlFor="bankAccount">Bank Account </Label>
                                            <Select
                                                id="bankAccount"
                                                name="bankAccount"
                                                value={values.bankAccount || ''}
                                                onChange={(e) => handleBankAccountChange(e, setFieldValue)}
                                                displayEmpty
                                                fullWidth
                                                className="px-2"
                                                style={{ height: "46px" }}
                                            >
                                                <MenuItem value="">
                                                    <em>Select Bank Account</em>
                                                </MenuItem>
                                                {bankAccounts.map((account) => (
                                                    <MenuItem key={account.id} value={account.id.toString()}>
                                                        {account.accountNum} - {account.holderName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </InputGroup>
                                    )}

                                    <InputGroup>
                                        <Label htmlFor="file">
                                            Document(optional)
                                        </Label>
                                        <FieldWrapper $select={true}>
                                            <Field
                                                required
                                                name="file"
                                                type="text"
                                                id="file"
                                                autoComplete="off"
                                            >
                                                {(props) => (
                                                    <DropZone
                                                        fields={props.field}
                                                        setFieldValue={props.form.setFieldValue}
                                                        componentFor="expense"
                                                        acceptedFiles="image/*,application/pdf"
                                                        File={props.field.value ? [props.field.value] : null}
                                                    />
                                                )}
                                            </Field>
                                        </FieldWrapper>
                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleClose}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={markPaidExpenseLoading}>
                                    {markPaidExpenseLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                            <PaidUserModal
                                isOpen={showPaidByModal}
                                onClose={() => setShowPaidByModal(false)}
                                onSelect={handleSelectedPaidBy}
                                options={expenseData?.users}
                                selectedPaidBy={selectedPaidBy}
                            />
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    )
}

const FieldWrapper = tw.div`w-full`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`
const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`
const OptionCard = tw.button`
  flex flex-col items-center justify-center p-3 rounded-lg shadow border border-gray-200 text-center
  cursor-pointer transition-all duration-200 
  ${(props) =>
        props.isselected === "true"
            ? "bg-primary-color/10 border-primary-color"
            : "bg-white hover:bg-gray-50"}
`;

export default MarkAsPaidOfflineModal